<script setup lang="ts">
import MarkdownIt from "markdown-it";

type PropsType = {
  content: {
    heading: string;
    content: string;
  };
};

const props = defineProps<PropsType>();
const heading = ref(props?.content?.heading);

const md = new MarkdownIt({
  html: true, // Enable HTML tags for phone number links
  linkify: true, // Enable auto-converting URL-like text to links
  breaks: true, // Convert \n to <br>
});

// Add custom renderer for phone links and PDF links
md.renderer.rules.link_open = (
  tokens: any,
  idx: any,
  options: any,
  env: any,
  self: any
) => {
  const token = tokens[idx];
  const href = token.attrGet("href");

  if (href && href.startsWith("tel:")) {
    // Format phone number by removing spaces
    const phone = href.replace("tel:", "").replace(/\s+/g, "");
    token.attrSet("href", `tel:${phone}`);
  }

  return self.renderToken(tokens, idx, options);
};

// Convert markdown content to HTML
const renderedContent = computed(() => {
  let cleanContent = props.content.content
    .split("\n")
    .map((line) => line.trim())
    .join("\n");

  // Find and format phone number links
  // Example: Call [02 5126 0000](tel:02 5126 0000)
  cleanContent = cleanContent.replace(
    /\[(\d[\d\s]+)\]\(tel:[\d\s]+\)/g,
    (match, phone) => {
      const cleanPhone = phone.replace(/\s+/g, "");
      return `[${phone}](tel:${cleanPhone})`;
    }
  );

  return md.render(cleanContent);
});
</script>

<template>
  <section class="max-w-7xl mx-auto border mb-[35px]">
    <div class="px-6 py-2 bg-primary text-white text-3xl">
      <h4>{{ heading }}</h4>
    </div>

    <div
      v-html="renderedContent"
      class="text-primary underline py-5 px-4 content-wrapper"
    ></div>
  </section>
</template>
